export default "__VITE_ASSET__DcvhGp_f__"